import {ApplicationsContainer} from './components/applications-container';

export default {
    component: ApplicationsContainer
};
